require('./formEditorHeader.i18n.json');
require('./formEditorHeaderController.js');
require('./formEditorHeader.tpl.html');
require('./formActionRepository.js');
require('./errorModal/formTemplateErrorModal.tpl.html');
require('./errorModal/formTemplateErrorModalController.js');

const FormEditorHeaderComponent = {
    templateUrl: '/configuration/formEditor/header/formEditorHeader.tpl.html',
    controller: 'formEditorHeaderController',
    bindings: {}
};

angular.module('ums')
    .component('uiFormEditorHeader', FormEditorHeaderComponent);
